var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(_vm._template=='auth')?_c('LayoutAuth'):(_vm._template=='app'&&_vm.$store.state.auth.currentUser)?_c('LayoutApp'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }